import { render, staticRenderFns } from "./device-menu.vue?vue&type=template&id=8c64a96a&scoped=true&"
import script from "./device-menu.vue?vue&type=script&lang=js&"
export * from "./device-menu.vue?vue&type=script&lang=js&"
import style0 from "./device-menu.vue?vue&type=style&index=0&id=8c64a96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c64a96a",
  null
  
)

export default component.exports